{
  // ヘッダのトグル
  document.querySelector('.header .toggle').addEventListener('click', () => {
    document.querySelector('.header').classList.toggle('header--toggle');
    document.querySelector('.toggleNavi').classList.toggle('toggleNavi--display');
    document.querySelector('.toggleNavi').classList.toggle('toggleNavi--active');
  });
}
